export function tratarValor(valor) {
    let novoValor = valor.replace(/[^\d,]/g, "");
    novoValor = novoValor.replace(',', ".");
    return novoValor;
}

export function tratarValorApi(valor) {
    return valor ? valor.replace('.', ',') : '';
}